import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-2347a5ca")
const _hoisted_1 = { class: "padding-button" }
const _hoisted_2 = ["title"]
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 0,
  class: "padding-button"
}
const _hoisted_10 = {
  key: 1,
  class: "points"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 3,
  class: "length"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 1,
  class: "center title-3"
}
const _hoisted_17 = {
  key: 0,
  class: "details"
}
const _hoisted_18 = { class: "system-info" }
const _hoisted_19 = { class: "multiline-text description" }
const _hoisted_20 = {
  key: 0,
  class: "files"
}
const _hoisted_21 = ["title", "onClick"]
const _hoisted_22 = ["title", "onClick"]
const _hoisted_23 = { class: "filename" }
const _hoisted_24 = { class: "end-date" }
const _hoisted_25 = { class: "created-by" }
const _hoisted_26 = {
  key: 0,
  class: "edited-by"
}
const _hoisted_27 = {
  key: 1,
  class: "edit"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_29 = { class: "center padding-b-10" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_control_grid = _resolveComponent("base-control-grid")!
  const _component_demand_form = _resolveComponent("demand-form")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, { class: "card-demand" }, {
    default: _withCtx(() => [
      _createVNode(_component_base_control_grid, { sideWidth: 200 }, {
        right: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!_ctx.editing)
              ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                  key: 0,
                  type: "delete",
                  class: "icon-button",
                  title: _ctx.$t('delete'),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteDemand()))
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true),
            (!_ctx.editing)
              ? (_openBlock(), _createElementBlock("dig-input-file", {
                  key: 1,
                  onLoaded: _cache[1] || (_cache[1] = ($event: any) => (_ctx.uploadFileDemand($event)))
                }, [
                  _createElementVNode("dig-ui-icon", {
                    type: "upload",
                    class: "icon-button",
                    title: _ctx.$t('upload')
                  }, null, 8, _hoisted_3)
                ], 32))
              : _createCommentVNode("", true),
            (!_ctx.editing && !_ctx.showDetail)
              ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                  key: 2,
                  type: "show",
                  class: "icon-button",
                  title: _ctx.$t('show'),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleShowDetail()))
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            (!_ctx.editing && _ctx.showDetail)
              ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                  key: 3,
                  type: "hide",
                  class: "icon-button",
                  title: _ctx.$t('hide'),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleShowDetail()))
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            (!_ctx.editing)
              ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                  key: 4,
                  type: "edit",
                  class: "icon-button",
                  title: _ctx.$t('edit'),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editing = true))
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.editing)
              ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                  key: 5,
                  type: "upload",
                  class: "icon-button",
                  title: _ctx.$t('close'),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validateEdition()))
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            (_ctx.editing)
              ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                  key: 6,
                  type: "close",
                  class: "icon-button",
                  title: _ctx.$t('close'),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editing = false))
                }, null, 8, _hoisted_8))
              : _createCommentVNode("", true)
          ])
        ]),
        left: _withCtx(() => [
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("dig-ui-badge", {
                  class: _normalizeClass({
              clickable: true,
              invalid: !_ctx.demand.customerChecked,
              valid: _ctx.demand.customerChecked,
            }),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateField('customerChecked', !_ctx.demand.customerChecked)))
                }, _toDisplayString(_ctx.project.name), 3),
                _createElementVNode("dig-ui-badge", {
                  class: _normalizeClass({
              clickable: _ctx.isAdmin,
              invalid: !_ctx.demand.providerChecked,
              valid: _ctx.demand.providerChecked,
            }),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateField('providerChecked', !_ctx.demand.providerChecked)))
                }, _toDisplayString('Digithia'), 2),
                _createElementVNode("dig-ui-badge", {
                  class: _normalizeClass({
              clickable: _ctx.isAdmin,
              'state-waiting': _ctx.demand.state === _ctx.DEMAND_STATES.WAITING,
              'state-processing': _ctx.demand.state === _ctx.DEMAND_STATES.PROCESSING,
              'state-done': _ctx.demand.state === _ctx.DEMAND_STATES.DONE,
              'state-abort': _ctx.demand.state === _ctx.DEMAND_STATES.ABORT,
            }),
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateField('state', _ctx.nextState(_ctx.demand.state))))
                }, _toDisplayString(_ctx.$t('Demand.State.' + _ctx.demand.state)), 3),
                (_ctx.demand.priority)
                  ? (_openBlock(), _createElementBlock("dig-ui-badge", {
                      key: 0,
                      class: _normalizeClass({
              clickable: true,
              'priority-low': _ctx.demand.priority === _ctx.DEMAND_PRIORITIES.LOW,
              'priority-medium': _ctx.demand.priority === _ctx.DEMAND_PRIORITIES.MEDIUM,
              'priority-high': _ctx.demand.priority === _ctx.DEMAND_PRIORITIES.HIGH,
              'priority-critic': _ctx.demand.priority === _ctx.DEMAND_PRIORITIES.CRITIC,
            }),
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateField('priority', _ctx.nextPriority(_ctx.demand.priority))))
                    }, _toDisplayString(_ctx.$t('Demand.Priority.' + _ctx.demand.priority)), 3))
                  : _createCommentVNode("", true),
                (_ctx.demand.points)
                  ? (_openBlock(), _createElementBlock("dig-ui-badge", _hoisted_10, [
                      (_ctx.demand.points < 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.demand.points) + " " + _toDisplayString(_ctx.$t('Demand.point')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.demand.points >= 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.demand.points) + " " + _toDisplayString(_ctx.$t('Demand.points')), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.demand.nature)
                  ? (_openBlock(), _createElementBlock("dig-ui-badge", {
                      key: 2,
                      class: _normalizeClass(["nature clickable", {
              'nature-fix': _ctx.demand.nature === _ctx.DEMAND_NATURES.FIX,
              'nature-improvement':
                _ctx.demand.nature === _ctx.DEMAND_NATURES.IMPROVEMENT,
            }]),
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateField('nature', _ctx.nextNature(_ctx.demand.nature))))
                    }, _toDisplayString(_ctx.$t('Demand.Nature.' + _ctx.demand.nature)), 3))
                  : _createCommentVNode("", true),
                (_ctx.demand.files)
                  ? (_openBlock(), _createElementBlock("dig-ui-badge", _hoisted_13, _toDisplayString(_ctx.$t('Demand.nbFiles', { n: _ctx.demand.files.length })), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        middle: _withCtx(() => [
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock("dig-ui-title", {
                key: 0,
                class: "center title-3",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showNotification()))
              }, [
                (_ctx.demand.name)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.demand.name), 1))
                  : _createCommentVNode("", true),
                (!_ctx.demand.name)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('Demand.demandOf', { name: _ctx.demand.createdBy?.username })), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.editing)
            ? (_openBlock(), _createElementBlock("dig-ui-title", _hoisted_16, _toDisplayString(_ctx.$t('Demand.edit')), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.showDetail && !_ctx.editing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.demand.version || _ctx.$t('Demand.noVersion')) + " - " + _toDisplayString(_ctx.demand.browser || _ctx.$t('Demand.noBrowser')) + " - " + _toDisplayString(_ctx.demand.os || _ctx.$t('Demand.noOS')), 1),
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.demand.description || _ctx.$t('Demand.noDescription')), 1),
            (_ctx.demand.files)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.demand.files, (file) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: file,
                      class: "file"
                    }, [
                      (!_ctx.editing)
                        ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                            key: 0,
                            type: "delete",
                            class: "icon-button",
                            title: _ctx.$t('delete'),
                            onClick: ($event: any) => (_ctx.deleteFileDemand(file))
                          }, null, 8, _hoisted_21))
                        : _createCommentVNode("", true),
                      (!_ctx.editing)
                        ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                            key: 1,
                            type: "download",
                            class: "icon-button",
                            title: _ctx.$t('download'),
                            onClick: ($event: any) => (_ctx.downloadFileDemand(file))
                          }, null, 8, _hoisted_22))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_23, _toDisplayString(file), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('Demand.createdBy', {
            name: _ctx.demand.createdBy?.username,
            date: _ctx.dateToCountdown(_ctx.demand.createDate),
          })), 1),
        (_ctx.demand.editedBy)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.$t('Demand.editedBy', {
            name: _ctx.demand.editedBy?.username,
            date: _ctx.dateToCountdown(_ctx.demand.updateDate || ''),
          })), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.editing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createVNode(_component_demand_form, {
              demand: _ctx.demandForm,
              project: _ctx.project,
              isAdmin: _ctx.isAdmin,
              onUpdate: _cache[13] || (_cache[13] = ($event: any) => (_ctx.update($event))),
              onCancel: _cache[14] || (_cache[14] = ($event: any) => (_ctx.cancelEdition()))
            }, null, 8, ["demand", "project", "isAdmin"]),
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("dig-ui-loader", _hoisted_30))
                : _createCommentVNode("", true),
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("dig-ui-standard-button", {
                    key: 1,
                    class: "cancel",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.cancelEdition())),
                    disabled: _ctx.loading
                  }, _toDisplayString(_ctx.$t('cancel')), 9, _hoisted_31))
                : _createCommentVNode("", true),
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("dig-ui-standard-button", {
                    key: 2,
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.validateEdition())),
                    disabled: _ctx.loading
                  }, _toDisplayString(_ctx.$t('validate')), 9, _hoisted_32))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}